module.exports = __webpack_public_path__ + "static/media/MHRP75N0008.26e1dc5b.svg";